/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const scrollHandler = () => {
  const onScroll = () => {
    const scroll = document.documentElement.scrollTop;
    if (scroll > 0) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  };

  // Use either onScroll or throttledOnScroll
  window.addEventListener('scroll', onScroll);
};

export default scrollHandler;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/scrollHandler.js